import React, { Component } from 'react'
import styles from './List.css'
import { dateFormatter, formatDecimal, rupiah } from 'utils/formatter'

class Row extends Component {

  render () {
    let {pointActivity} = this.props
    return (
      <tr className={`${this.props.isSelected ? styles.selected : ''}`} onClick={this._onClickRow}>
        <td className={styles['date']}>{dateFormatter(pointActivity.created_at)}</td>
        <td className={styles['outlet']}>{pointActivity.outlet_name}</td>
        <td className={styles['sale']}>{this._saleFormatter(pointActivity.total_collected_amount)}</td>
        <td className={styles['point']}>{this._getFormattedPoint()}</td>
      </tr>
    )
  }

  _saleFormatter = (sale) => {
    return sale < 0 ? `(${rupiah(-sale)})` : rupiah(sale)
  }

  _getFormattedPoint = () => {
    let {pointActivity} = this.props
    const point = pointActivity.points + pointActivity.new_member_points
    if (pointActivity.type.toUpperCase() === 'EARNING') {
      if (point >= 0) {
        return formatDecimal(point)
      } else {
        // this is for the case of refund, the point will be minus
        return `(${formatDecimal(-point)})`
      }
    } else {
      return `(${formatDecimal(point)})`
    }
  }

  _onClickRow = () => {
    this.props.onClickRow(this.props.pointActivity.payment_type.toLowerCase(), this.props.pointActivity.parent_payment_id, this.props.pointActivity.row_id)
  }
}

export default Row



// WEBPACK FOOTER //
// ./app/pages/Customers/CustomerList/PointActivity/List/Row.js